<body>
  <div class="flex justify-content-between flex-wrap" style="margin-bottom: 35px;">
    <div class="col-3">
      <span style="font-size: 24px; font-weight: 600;">Distributor Partners</span>
    </div>
    <app-permission-wrapper permission="CanAddDistributor">
      <div class="p-col-3" style="text-align:right;  cursor: pointer;" (click)="openModal()">
        <button pButton type="button" class="add-button btn-primary" pRipple>
          <i class="pi pi-plus" style="vertical-align: middle;"></i>
          <span style="margin-left: 8px;">Add Distributor Partner</span>
        </button>
      </div>
    </app-permission-wrapper>
  </div>
  <p-tabView (onChange)="onTabChange($event)">
    <p-tabPanel [header]="'Submitted (' + submittedCount + ')'" pRipple>
      <app-service-distributor-status #submittedTab [status]="1"></app-service-distributor-status>
    </p-tabPanel>
    <p-tabPanel [header]="'In review (' + inReviewCount + ')'" pRipple>
      <app-service-distributor-status #inReviewTab [status]="2"></app-service-distributor-status>
    </p-tabPanel>
    <p-tabPanel [header]="'Approved (' + approvedCount + ')'" pRipple>
      <app-service-distributor-status #approvedTab [status]="3"></app-service-distributor-status>
    </p-tabPanel>
    <p-tabPanel [header]="'Rejected/Disabled (' + rejectedCount + ')'" pRipple>
      <app-service-distributor-status #rejectedTab [status]="4"></app-service-distributor-status>
    </p-tabPanel>
  </p-tabView>

  <app-add-distributor *ngIf="showModal" (updateServiceDistributorList)="updateListOnOwnerSuccess()"
    (closeDialog)="showModalW()"></app-add-distributor>
</body>